import { render, staticRenderFns } from "./EscalafonPage.vue?vue&type=template&id=b00f4b00"
import script from "./EscalafonPage.js?vue&type=script&lang=js&external"
export * from "./EscalafonPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports